import { DocumentUtils, pageService } from '@ol/ol-ui-core';

class ThirdPartyJavascriptSupport {
  async init(plId: number) {
    const thirdPartyJavascriptConfig = await pageService.getThirdPartyJavaScriptConfig(plId);
    if (thirdPartyJavascriptConfig) {
      if (thirdPartyJavascriptConfig.stockwave && thirdPartyJavascriptConfig.stockwave.enabled) {
        // @ts-ignore
        await DocumentUtils.loadScript(thirdPartyJavascriptConfig.stockwave.url);
        (window as any).stockwave.initialize();
      }
    }
  }
}


export const thirdPartyJavascriptSupport = new ThirdPartyJavascriptSupport();
